import { TronicPayloadMethod } from '@tronic-sdk/types';

import { BaseModule } from './base-module';
import { createJsonRpcRequestPayload } from '../core/json-rpc';

export class WalletModule extends BaseModule {
  public showUI = () => {
    return this.request<boolean>(createJsonRpcRequestPayload(TronicPayloadMethod.ShowUI));
  };
}
